import moment from 'moment'

/**
 * Convert a 12H-formatted time string (AM/PM, short or leading zero) to it's counterpart in 24H format.
 *
 * @param {string} timeString12H - A time string in 12H format (e.g.: '7:34 PM')
 * @return {string} - The input time string in 24H format (e.g.: '19:34')
 */
export function toTimeString24H(timeString12H) {
    if (typeof timeString12H === 'string' && /^1?[0-9]:[0-5][0-9] [ap]m$/i.test(timeString12H)) {
        return moment(timeString12H, 'hh:mm a').format('HH:mm')
    }

    if (typeof timeString12H === 'string' && /^[01][0-9]:[0-5][0-9] [ap]m$/i.test(timeString12H)) {
        return moment(timeString12H, 'HH:mm a').format('HH:mm')
    }

    // default return to avoid that numbers are formatted to a time string in an uncontrolled way
    return 'Invalid date'
}
